<template>
  <div>
    <Head :title="$t('interventions.interventions')"/>
    <h1 class="mb-8 text-3xl font-bold">{{ $t('interventions.interventions') }}</h1>
    <table-head-filter :buttons="buttons"/>
    <Table
      :resource="data"
      class="custom-table-layout rounded"
      url-to-view="interventions"
    >
      <template #cell(date)="{ item: data }">
        {{ $filters.formatDate(data.date) }}
      </template>
      <template #cell(status)="{ item: data }">
        <status-badge :status="data.status"/>
      </template>
    </Table>
  </div>
</template>
<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Table from '@/Shared/Table/Components/Table'
import StatusBadge from '@/Shared/StatusBadge'
import TableHeadFilter from '@/Shared/TableHeadFilter'

export default {
  components: {
    Head,
    TableHeadFilter,
    Table,
    StatusBadge,
  },
  layout: Layout,
  props: {
    data: Object,
    buttons: Array,
  },
  computed: {
    currentUrl() {
      return window.location.href
    },
  },
}
</script>
